import { render, staticRenderFns } from "./GreenEnergyDetail.vue?vue&type=template&id=5e966133&scoped=true"
import script from "./GreenEnergyDetail.vue?vue&type=script&lang=js"
export * from "./GreenEnergyDetail.vue?vue&type=script&lang=js"
import style0 from "./GreenEnergyDetail.vue?vue&type=style&index=0&id=5e966133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e966133",
  null
  
)

export default component.exports